"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function ScopeSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-white py-10 px-4 md:px-6">
      <div className="max-w-[880px] mx-auto">
        <div className="bg-[#fefce8] rounded-xl border-l-4 border-[#047857] p-6">
          <h3 className="text-lg font-bold text-[#064e3b] mb-2">{t("sliding.scopeHeading")}</h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            {t("sliding.scopeText")}
          </p>
        </div>
      </div>
    </section>
  );
}